export default __webpack_public_path__ + "static/logoticker_bazaar-6647c536decb6f73ca4896078b0b4329.svg";